import {BookingOption} from '../enums/BookingOption';
import {CouponType} from '../enums/CouponType';
import {CouponStatus} from '../enums/CouponStatus';
import {SimpleUser} from './SimpleUser';

export class OfficeCoupon {
  id: number;
  value: number;
  type: CouponType;
  bookingOption: BookingOption;
  code: string;
  expirationDate: Date;
  status: CouponStatus;
  usedBy: SimpleUser;
  usedAt: Date;
  fullAmount: number;
  paidAmount: number;
  createdDate: Date;
  createdBy: SimpleUser;

  public constructor(init?: Partial<OfficeCoupon>) {
    Object.assign(this, init);
  }
}
